import actions from 'redux/actions'
import { constants, snowplow } from 'common/helpers'

import messages from './messages'

import generateButton from '../generateButton/generateButton'


export default generateButton({
  displayName: 'AddToQueueButton',
  action: actions.models.queue.addItem,
  defaultTitle: messages.defaultTitle,
  onClick: (props) => {
    const {
      product: { id, name, category, upchargePrice },
      snowplowMetadata: { placement },
    } = props

    let realUpchargePrice = (String(upchargePrice).match(/\d+(?:\.\d+)?/) || [])[0]
    if (realUpchargePrice) {
      realUpchargePrice = parseFloat(realUpchargePrice) / 100
    }

    snowplow.track(constants.snowplowEvents.addToQueue, {
      productId: id,
      productName: name,
      productCategory: category,
      upchargePrice: realUpchargePrice || null,
      placement,
    }, false)
  },
})
